import React, {useState} from 'react'
import {makeStyles} from '@material-ui/core'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'

interface ICollapsibleProps {
    title?: string
    isCollapsed?: boolean
    zeroSpace?: boolean
}

const useStyles = makeStyles({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #e6e3e0',
        borderRadius: 4,

        '&:not(:last-child)': {
            marginBottom: 8,
        },
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        justifyContent: 'space-between',
        backgroundColor: '#e6e3e0',
        padding: '0 8px',
        fontSize: 12,
        height: 28,

        '& h3': {
            margin: 0,
        },
    },
    collapseButton: {
        cursor: 'pointer',
    },
    content: {
        padding: 8,
    },
    overflow: {
        overflow: 'hidden',
    },
    zeroSpace: {
        padding: 0,
        margin: -1,
    },
})

const Collapsible: React.FC<ICollapsibleProps> = ({title, isCollapsed, zeroSpace, children}) => {
    const [collapsed, setCollapsed] = useState(!!isCollapsed)
    const classes = useStyles()

    const toggleCollapsed = () => setCollapsed(!collapsed)

    const Icon = collapsed ? ExpandMoreIcon : ExpandLessIcon
    const wrapperClass = [classes.wrapper]
    const contentClass = [classes.content]
    if (zeroSpace) {
        wrapperClass.push(classes.overflow)
        contentClass.push(classes.zeroSpace)
    }
    return (
        <section className={wrapperClass.join(' ')}>
            <div className={classes.header} onClick={toggleCollapsed}>
                <h3>{title}</h3>

                <Icon
                    className={classes.collapseButton}
                />
            </div>

            {!collapsed && (
                <div className={contentClass.join(' ')}>
                    {children}
                </div>
            )}
        </section>
    )
}

export default Collapsible
